import { safeGetItem, safeRemoveItem, safeSetItem } from "../utils/storage";

export const POST_LOGIN_REDIRECT_KEY = "myculturePostLoginRedirect";

export function normalizePostLoginRedirect(
  value: unknown,
  fallback = "/"
): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }
  try {
    const base = new URL("https://app.myculture.invalid");
    const url = new URL(value, base);
    if (url.origin !== base.origin || ["/login", "/th/login"].includes(url.pathname)) {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

export function savePostLoginRedirect(value: unknown): string {
  const normalized = normalizePostLoginRedirect(value);
  safeSetItem(POST_LOGIN_REDIRECT_KEY, normalized);
  return normalized;
}

export function getPostLoginRedirect(fallback = "/"): string {
  return normalizePostLoginRedirect(safeGetItem(POST_LOGIN_REDIRECT_KEY), fallback);
}

export function takePostLoginRedirect(fallback = "/"): string {
  const redirect = getPostLoginRedirect(fallback);
  safeRemoveItem(POST_LOGIN_REDIRECT_KEY);
  return redirect;
}

export function connectorAuthorizationQuery(
  tab: string,
  query: Record<string, unknown>
): { oauth_request: string } | Record<string, never> {
  const requestToken = tab === "Client_API" ? query.oauth_request : undefined;
  return typeof requestToken === "string" && requestToken
    ? { oauth_request: requestToken }
    : {};
}
